"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _meta = require("./meta");
var _SnetFooterColumn = _interopRequireDefault(require("../SnetFooterColumn"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SnetFooterColumns = () => {
  const classes = (0, _styles.useStyles)();
  const FooterColumnsContent = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _meta.columnsMeta.map(column => /*#__PURE__*/_react.default.createElement(_SnetFooterColumn.default, {
      key: column.key,
      column: column
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.columnsContainer
  }, /*#__PURE__*/_react.default.createElement(FooterColumnsContent, null)));
};
var _default = exports.default = SnetFooterColumns;